
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddShipRepairPracticeRequest,
    factory, PracticesClient,
    ShipRepairPracticeActions,
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import ShipRepairPracticeUpsertForm from "@/features/documents/practices/components/ShipRepairPracticeUpsertForm.vue";
import {PracticeAddBase} from "@/features/documents/practices/views/PracticeAddBase";

interface Props {
    seafarerId: string;
    actions: ShipRepairPracticeActions;
}

@Component({
    components: {
        FormLayout,
        ShipRepairPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<AddShipRepairPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        Promise.all([
            new PracticesClient().availableShipRepairActions()
        ]).then(values => {
            props.actions = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class AddShipRepairPractice extends PracticeAddBase<AddShipRepairPracticeRequest> implements Props {
    @Prop({required: true})
    seafarerId!: string;
    @Prop({required: true})
    actions!: ShipRepairPracticeActions;

    model: AddShipRepairPracticeRequest = factory.create(
        AddShipRepairPracticeRequest
    );

    async submitPractice() {
        return await this.submit(this.model);
    }

    getDefaultReturnRouteName(model: AddShipRepairPracticeRequest): string {
        return "ship-repair-practice-details";
    }
}
